import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Button, Grid, SvgIcon } from "@material-ui/core";
import { ReactComponent as Logo } from "../images/discountRequest.svg";
import BlockIcon from "@material-ui/icons/Block";
import CallIcon from "@material-ui/icons/Call";
import EmailIcon from "@material-ui/icons/Email";
import SmsIcon from "@material-ui/icons/Sms";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Typography from "@material-ui/core/Typography";
import http from "../services/httpService";
import {
  getDate,
  prospectDetailsPath,
  toHHMMSS,
  getTime,
  getDateTime,
  investmentDetailsPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import { useHistory, useRouteMatch } from "react-router-dom";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import toast from "react-hot-toast";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
});
function ActivityLog() {
  const location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(true);
  const [overview, setOverview] = useState({});
  const [activityDetails, setActivityDetails] = useState([]);
  const myparam = location.state;
  useEffect(() => {
    getActivityList()
  }, []);
  const getActivityList = () => {
    toast.loading("Please wait...");
    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      let cust_id = myparam.cust__id || myparam.customer_id;
      http
        .get("/activity_log/" + cust_id)
        .then((res) => {
          toast.dismiss()
          // (res);
          if (
            res &&
            res.data &&
            res.data.activity_count &&
            res.data.activity_count.length > 0
          ) {
            setOverview(res.data.activity_count[0]);
          }
          else {
            // console.log(res.data, 'ress');
            toast.error(res.data.data);
          }
          if (
            res &&
            res.data &&
            res.data.data &&
            Array.isArray(res.data.data) &&
            res.data.data.length > 0
          ) {
            setActivityDetails(res.data.data);
          }

        })
        .catch((err) => { });
    }
  }
  const gotoProspectDetails = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };
  return (
    <Grid
      container
      style={showWindow ? { display: "block" } : { display: "none" }}
    >
      <Paper className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={6} md={1}>
            <Button
              name="Overview"
              variant="contained"
              color="primary"
              onClick={gotoProspectDetails}
            >
              Overview
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Grid container style={{ marginTop: "10px" }}>
        <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
          <Typography color="textPrimary" variant="h5">
            Activity Log
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Last Login</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Last Logout</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Login Count</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">App Visits</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Web Visits</Typography>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{getDate(overview.last_login)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{getDate(overview.last_logout)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{overview.Login_Count}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{overview.AppVisits}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{overview.WebVisits}</Typography>
        </Grid>
      </Grid>
      {/* <Grid container style={{ marginTop: "20px" }}>
            <Grid item xs={12} sm={12} md={12} style={{ border: "1px", borderRadius: "10%", borderColor: "black" }}>

                <Stepper

                    orientation="vertical"
                    nonLinear
                    defaultColor="primary"
                >
                    <Step>
                        <Grid container>
                            <Grid item xs={6} sm={4} md={3} style={{paddingLeft:10,fontWeight:500}}>Calls Answered</Grid>
                            <Grid item xs={6} sm={4} md={3} style={{paddingLeft:20,fontWeight:500}}>Calls Not Answered</Grid>
                            <Grid item xs={6} sm={4} md={3} style={{paddingLeft:20,fontWeight:500}}>Calls Rejected</Grid>
                        </Grid>
                    </Step>
                    {activityDetails.map((label, index) => {
                        return (
                            <Step key={label.id} active>
                                <StepLabel icon={<FiberManualRecordIcon style={{width:"10px",height:"10px"}}/>}>
                                    <Grid container>
                                        <Grid item xs={6} sm={4} md={3}>{getDateTime(label.date)}</Grid>
                                        <Grid item xs={6} sm={4} md={3}>{label.activity}</Grid>
                                        <Grid item xs={6} sm={4} md={3}>{label.activity}</Grid>
                                    </Grid>
                                </StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
            </Grid>

        </Grid> */}

      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Calls Answered</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Calls Not Answered</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="caption">Calls Rejected</Typography>
        </Grid>
      </Grid>

      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{overview.answered}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{overview.notanswered}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6">{overview.rejected}</Typography>
        </Grid>
      </Grid>

      <div>
        {/* <div>
            <h2>Date and Time</h2>
            <p>{activityDetails.map(item=>{
                return(
                    <>
                        {getDate(item.date)}
                        { getTime(item.date)} 
                    </>
                )
            })}</p>
            </div>
            <div>
                <h2>Action</h2>
                <p>{activityDetails.map(item=>{
                return(
                    <>
                        {item.activity}                        
                    </>
                )
            })}</p>
            </div> */}
        <Grid container style={{ marginTop: "50px", border: '2px solid #707070', borderRadius: '20px', padding: '30px' }}>
          <Grid item xs={12} sm={12} md={12} style={{ border: "1px", borderRadius: "10%", borderColor: "black" }}>

            <Stepper

              orientation="vertical"
              nonLinear
              defaultColor="primary"
            >
              <Step>
                <Grid container>
                  <Grid item xs={6} sm={4} md={3} style={{ paddingLeft: 10, fontWeight: 500 }}>Date and Time</Grid>
                  <Grid item xs={6} sm={4} md={3} style={{ paddingLeft: 20, fontWeight: 500 }}>Action</Grid>
                  {/* <Grid item xs={6} sm={4} md={3} style={{paddingLeft:20,fontWeight:500}}>Calls Rejected</Grid> */}
                </Grid>
              </Step>
              {activityDetails.map((label, index) => {
                return (
                  <Step key={label.id} active>
                    <StepLabel icon={<FiberManualRecordIcon style={{ width: "10px", height: "10px" }} />}>
                      <Grid container>
                        <Grid item xs={6} sm={4} md={3}>{getDateTime(label.date)}</Grid>
                        <Grid item xs={6} sm={4} md={3}>{label.activity}</Grid>
                        {/* <Grid item xs={6} sm={4} md={3}>{label.activity}</Grid> */}
                      </Grid>
                    </StepLabel>
                  </Step>
                )
              })}
            </Stepper>
          </Grid>

        </Grid>
      </div>
    </Grid>
  );
}

export default ActivityLog;
